import React, { useEffect, useRef, useState } from 'react'
import DOMPurify from 'dompurify'
import linkifyHtml from 'linkifyjs/html'
import { marked } from 'marked'

function parseMarkdown(text) {
  return marked(text)
}

DOMPurify.addHook('afterSanitizeAttributes', function (node) {
  if ('target' in node) {
    node.setAttribute('target', '_blank')
  }
})

function LinkPreview (props) {
  const [previewData, setPreviewData] = useState(null)
  var url
  const candidates = props.text.split(' ').filter(t => t.includes('href'))
  if (candidates.length) {
    const lastCandidate = candidates[candidates.length - 1]
    url = lastCandidate.split('\"')[1]
    if (!url.includes('http')) {
      url = 'https://' + url
    }
  }

  useEffect(() => {
    if (!previewData) {
      const headers = {
        'Content-Type': 'application/vnd.api+json',
        Pragma: 'no-cache'
      }
      if (url) {
        fetch(`https://${window.location.host}/api/link-preview-service/preview?` + new URLSearchParams({ url: url }), {
          method: 'GET',
          header: headers
        }).then(response => response.json()).then(response => {
          setPreviewData({
            title: response.data.attributes.title,
            description: response.data.attributes.description,
            image: response.data.attributes.image
          })
        })
      }
    }
  }, [previewData, url])

  return (
    <div
      className={props.className}
      style={{ marginLeft: -5, maxWidth: 'calc(100% - 20px)', paddingLeft: 10, paddingRight: 10 }}
      key={props.key}
    >
      <div
        ref={props.divRef}
        dangerouslySetInnerHTML={{ __html: props.text }}
        style={{ color: 'inherit' }}
      />
      {Boolean(previewData && previewData.description) &&
        <a href={url} target='_blank' rel='noopener noreferrer' style={{ textDecoration: 'none', color: 'inherit' }}>
          <div style={{ marginTop: 10, cursor: 'pointer' }}>
            <div style={{ display: 'flex' }}>
              {previewData.image &&
                <div style={{ maxHeight: 80, marginRight: 10 }}>
                  <img src={previewData.image} width={80} />
                </div>}
              <div style={{ fontSize: '14px', fontWeight: 600 }}>
                {previewData.title}
              </div>
            </div>
            <div style={{
              fontSize: '13px',
              overflow: 'hidden',
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical'
            }}
            >
              {previewData.description}
            </div>
          </div>
        </a>}
    </div>
  )
}

function RenderEmoji (props) {
  const divRef = useRef()

  // AI response text can contain markdown, so we need to parse to HTML
  const textWithLinks = parseMarkdown(props.text)
  const linked = linkifyHtml(textWithLinks, { defaultProtocol: 'https' })
  if (linked.includes('<a href=') && !(linked.includes('mailto'))) {
    return (
      <LinkPreview
        className={props.className}
        text={DOMPurify.sanitize(linked)}
        divRef={divRef}
      />
    )
  }

  if (props.rich) {
    return (
      <div
        style={{ whiteSpace: 'pre-wrap' }}
        className={props.className}
        ref={divRef}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.text) }}
      />
    )
  }

  return (
    <div className={props.className} ref={divRef}>{props.text}</div>
  )
}

export default RenderEmoji
